import { render } from "./SchoolType.vue?vue&type=template&id=5c07ffe4"
import script from "./SchoolType.vue?vue&type=script&lang=js"
export * from "./SchoolType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__